import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
let SCROLLED = false;

function boostCustomInputFocusScrollBlock(e) {
  const searchInput = e.target;
  const containerButtons = document.querySelector('.boost-sd__in-collection-search-header--search-and-buttons');
  const filterViewAs = document.querySelector('.boost-sd__in-collection-search-header--filter-view-as');

  if (!searchInput || !containerButtons || !filterViewAs) return;

  if (window.matchMedia("(max-width: 990px)").matches) {

    const currentScrollY = window.scrollY;
    const filterViewAsTop = filterViewAs.getBoundingClientRect().top + window.pageYOffset;


    if (Math.abs(currentScrollY - filterViewAsTop - 100)) {
      if (!SCROLLED) {
      requestAnimationFrame(() => {
        window.scrollTo({ top: filterViewAsTop - 100, behavior: 'instant' });
      });
      }
    }

    SCROLLED = true;
    disableBodyScroll(containerButtons, { reserveScrollBarGap: true });

  }

  const resetBottom = () => {
    containerButtons.style.bottom = "0";
    SCROLLED = false;
    enableBodyScroll(containerButtons);
  };

  searchInput.addEventListener("blur", resetBottom, { once: true });

  document.addEventListener("touchstart", (event) => {
    if (!searchInput.contains(event.target)) {
      searchInput.blur();
      setTimeout(() => {
        SCROLLED = false;
        enableBodyScroll(containerButtons);
        containerButtons.style.bottom = "0";
      }, 100);
    }
  },{ once: true });
}

document.addEventListener('boostEvent:scrollblock', boostCustomInputFocusScrollBlock);
